var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerRecicladordeBaseTipoA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 110,
    viewBox: "0 0 100 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 82.5085V27.5085L50.0089 0L0 27.5085V82.5085L50.0089 110L100 82.5085Z",
    fill: "url(#paint0_linear_1101_118)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.967 81.1456V28.6154L50.2288 2.35034L2.47266 28.6154V81.1456L50.2288 107.411L97.967 81.1456Z",
    fill: "url(#paint1_linear_1101_118)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7966 79.7834V29.5697L50.1503 4.46289L4.50391 29.5697V79.7834L50.1503 104.89L95.7966 79.7834Z",
    fill: "url(#paint2_linear_1101_118)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4861 10.3907L90.7507 32.5338V76.82L50.4861 98.963L10.2215 76.82V32.5338L50.4861 10.3907ZM50.4861 9.69238L9.5957 32.1761V77.1606L50.4861 99.6614L91.3765 77.1606V32.1761L50.4861 9.69238Z",
    fill: "url(#paint3_linear_1101_118)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2021 85.3027L51.6325 88.028L54.7972 88.4709L52.5086 90.6L53.045 93.5979L50.2021 92.1841L47.3772 93.5979L47.9136 90.6L45.625 88.4709L48.7897 88.028L50.2021 85.3027Z",
    fill: "#FFC450"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0565 82.5082L61.9862 84.2967L64.0781 84.5862L62.5584 85.9829L62.916 87.9588L61.0565 87.022L59.197 87.9588L59.5546 85.9829L58.0527 84.5862L60.1268 84.2967L61.0565 82.5082Z",
    fill: "#FFC450"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9237 82.5082L40.8534 84.2967L42.9274 84.5862L41.4256 85.9829L41.7831 87.9588L39.9237 87.022L38.0642 87.9588L38.4218 85.9829L36.9199 84.5862L38.9939 84.2967L39.9237 82.5082Z",
    fill: "#FFC450"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1101_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1023 37.6515L39.7468 31.5163L42.3719 27.0896C43.3658 25.407 45.7615 25.407 46.7555 27.0896L50.5275 33.4578L47.3927 38.7905L44.844 42.9842L36.1023 37.6515ZM76.7528 52.7177L72.675 45.8318L63.8568 51.0092L69.4892 60.5615H72.3692C74.3061 60.5615 76.0647 59.4484 76.9312 57.688C77.288 56.9632 77.4664 56.1866 77.4664 55.3841C77.4664 54.4522 77.2116 53.5461 76.7528 52.7177ZM62.1747 73.505H65.9976C67.9346 73.505 69.6931 72.3918 70.5597 70.6315L74.2552 63.1502H62.1747V57.9728L51.9802 68.3276L62.1747 78.6824V73.505ZM46.8829 63.1502H35.9239L33.783 66.8003C33.0184 68.0946 32.9674 69.6996 33.6301 71.0716C34.3437 72.5472 35.8474 73.505 37.504 73.505H46.8829V63.1502ZM36.9943 56.2901L41.4034 58.9824L37.9118 44.7704L23.9453 48.3169L28.278 50.9574L27.233 52.7436C26.341 54.271 26.2646 56.1348 27.0546 57.7139L31.2089 66.1531L36.9943 56.2901ZM64.7743 32.4482L61.4611 26.8307C60.5181 25.2775 58.8615 24.3197 57.0774 24.3197H48.0808L56.0325 37.7809L51.6489 40.4473L65.6408 43.9938L69.1324 29.7819L64.7743 32.4482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1101_118",
    x: 19.9453,
    y: 24.3197,
    width: 61.5215,
    height: 62.3627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1101_118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1101_118",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_118",
    x1: -7.08618,
    y1: 97.0093,
    x2: 90.9962,
    y2: 17.4887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2181,
    stopColor: "#AA6A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#FEF9AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "#FBF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5943,
    stopColor: "#F4E799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    stopColor: "#E8D281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6755,
    stopColor: "#D7B360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7185,
    stopColor: "#C28C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7278,
    stopColor: "#BD832B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC9F47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1101_118",
    x1: 13.9093,
    y1: 32.2069,
    x2: 99.3744,
    y2: 90.9965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#E7A426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#B16F19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1101_118",
    x1: 81.879,
    y1: 95.5169,
    x2: 24.8551,
    y2: 14.6538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#915A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4884,
    stopColor: "#E8AC34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#905C09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1101_118",
    x1: 9.59499,
    y1: 54.6745,
    x2: 91.3844,
    y2: 54.6745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003861,
    stopColor: "#FDC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9235"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerRecicladordeBaseTipoA);
export default __webpack_public_path__ + "static/media/markerRecicladordeBaseTipoA.0e432f072b33d20b719ef7a4b700dc86.svg";
export { ForwardRef as ReactComponent };